var normalizeComponent = require("!../../../../../raypro-client/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../../../raypro-client/node_modules/vue-loader/lib/selector?type=script&index=0!./EnterRegistrationKey.vue"
import __vue_script__ from "!!babel-loader!../../../../../raypro-client/node_modules/vue-loader/lib/selector?type=script&index=0!./EnterRegistrationKey.vue"
/* template */
import __vue_template__ from "!!../../../../../raypro-client/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-993dc7e8\",\"hasScoped\":false,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../../../raypro-client/node_modules/vue-loader/lib/selector?type=template&index=0!./EnterRegistrationKey.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/components/ui/forms/EnterRegistrationKey.vue
// module id = null
// module chunks = 